import { useState, useEffect } from 'react';
import './SuccessPage.css'; 

const SuccessPage = () => {
  const [message, setMessage] = useState('');
  const [showPage, setShowPage] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const paymentStatus = sessionStorage.getItem('paymentStatus');
    const savedMessage = sessionStorage.getItem('message');
  
    if (paymentStatus === 'success') {
      setMessage(savedMessage || 'Your trial has been successfully booked.');
      setShowPage(true);
      setIsError(false);
  
    } else {
      setMessage('Invalid access. Please book a trial first.');
      setShowPage(false);
      setIsError(true);
  
      setTimeout(() => {
        window.location.href = '/';
      }, 3000);
    }
  }, []);
  
  const handleConfirm = () => {
    window.location.href = '/';
  };

  const handleContactSupport = () => {
    window.open('https://wa.me/+919663979929?text=Hello%20Machaxi', '_blank');
  };

  return (
    <div className="success-page-container">
      <div className="premium-glow" style={{ top: '20%', left: '10%' }} />
      <div className="premium-glow" style={{ bottom: '20%', right: '10%' }} />
      
      <div className={`success-message-container ${isError ? 'error-state' : 'success-state'}`}>
        <div className="icon-container">
          {isError ? (
            <div className="error-icon">⚠</div>
          ) : (
            <div className="success-icon">✓</div>
          )}
        </div>
        <p className="success-message">{message}</p>
        
        {!showPage && (
          <p className="redirect-message">
            Redirecting to homepage...
          </p>
        )}
      </div>
      
      {showPage && (
        <div className="actions-container">
          <button className="go-home-button" onClick={handleConfirm}>
            Return to Home
          </button>
          <button className="contact-support-button" onClick={handleContactSupport}>
            Contact Support
          </button>
        </div>
      )}
    </div>
  );
};

export default SuccessPage;